// Custom interrelations between content items.

import { CONTENT_ITEM_SINGLE, HOME } from '../path';

const relationMap = {
  [CONTENT_ITEM_SINGLE]: {
    'coauthors.0.relatedPosts': {
      path: 'authorRelated',
      eager: true,
    },
    relatedPosts: {
      path: 'relatedPosts',
      eager: true,
    },
  },
  [HOME]: {
    'homepage.articles': {
      path: 'articles',
      eager: true,
    },
  },
};

export default relationMap;
